import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import lv from './lv.json';

/** UI texts only through keys (engineering.md §2.6); `lv` is primary, `en` must have the same keys (C8). */
export const LANGUAGES = ['lv', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];
export const RESOURCES = { lv, en } as const;

const STORAGE_KEY = 'pmai.language';

function initialLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'lv' || stored === 'en') return stored;
  } catch {
    // storage unavailable (private mode) — use the default
  }
  return 'lv';
}

void i18n.use(initReactI18next).init({
  resources: { lv: { translation: lv }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'lv',
  interpolation: { escapeValue: false },
  showSupportNotice: false,
});

export function setLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // not persisted — fine
  }
}

export default i18n;
